module.exports = __webpack_public_path__ + "img/IMG-20190905-WA0018.28cd6461.jpg";